module.exports = __webpack_public_path__ + "img/1729042993348-image.jpg.d1280e31.webp";